import { Box, Button, Flex, Heading, Input, InputGroup, SimpleGrid, Text } from '@chakra-ui/react';
import { UseFormReturn, useController } from 'react-hook-form';
import { useDebouncedFieldRegistry } from '@/utils/filterUtils/useDebouncedFieldRegistry';
import { ChakraFeatherIcon } from 'src/components/ChakraFeatherIcon';
import { PartnersFilters } from '../../../../types';
import { DateRangeFilterFields } from 'src/components/DateRangeFilterFields';
import { DateRangeChangeHandler } from 'src/components/DateRangeFilterFields/types';
import { useTranslation } from 'react-i18next';

export interface PartnersFiltersBoxProps {
  filtersForm: UseFormReturn<PartnersFilters>;
}

export const PartnersFiltersBox = ({ filtersForm }: PartnersFiltersBoxProps) => {
  const { t } = useTranslation();
  const { register, reset, control } = filtersForm;
  const dateValueControl = useController({
    name: 'dateValue',
    control,
  });
  const startDateControl = useController({
    name: 'start_date',
    control,
  });
  const endDateControl = useController({
    name: 'end_date',
    control,
  });

  const handleRangeChange: DateRangeChangeHandler = (startDate, endDate) => {
    startDateControl.field.onChange(startDate);
    endDateControl.field.onChange(endDate);
  };

  return (
    <Box>
      <Flex align='center' gap='pico' mb='deka'>
        <ChakraFeatherIcon color='text.main' name='filter' />
        <Heading variant='sectionTitle'>{t('pages.partners.partners_section.components.partners_filters_box.partners_filters_title')}</Heading>
      </Flex>

      <Flex direction={{ base: 'column' }} gap='small' rowGap='micro'>
        <SimpleGrid gap='deka' alignItems='flex-end' columns={{ base: 1, md: 2, lg: 4, '10xl': 5 }} rowGap='xxsmall' flexGrow={1}>
          <InputGroup display='flex' flexDirection='column'>
            <Text fontWeight='medium'>{t('pages.partners.partners_section.components.partners_filters_box.partners_filters_partner_label')}</Text>
            <Input variant='flushed' {...useDebouncedFieldRegistry(() => register('name'))} />
          </InputGroup>
        </SimpleGrid>
        <SimpleGrid gap='deka' alignItems='flex-end' columns={{ base: 1, md: 2, lg: 3, '10xl': 5 }} rowGap='xxsmall' flexGrow={1}>
          <DateRangeFilterFields
            onRangeChange={handleRangeChange}
            startDate={startDateControl.field.value}
            endDate={endDateControl.field.value}
            dateValue={dateValueControl.field.value}
            onDateValueChange={dateValueControl.field.onChange}
          />
        </SimpleGrid>

        <Button alignSelf={{ lg: 'end' }} colorScheme='text' variant='outline' mt='10px' onClick={() => reset()}>
          {t('pages.partners.partners_section.components.partners_filters_box.partners_filters_clear_button')}
        </Button>
      </Flex>
    </Box>
  );
};
